import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../assets/logo_wTVision_small.png'
import _imports_1 from '../assets/admin.png'
import _imports_2 from '../assets/logout.png'
import _imports_3 from '../assets/back.png'
import _imports_4 from '../assets/validate.png'
import _imports_5 from '../assets/invalidate.png'
import _imports_6 from '../assets/next.png'


const _hoisted_1 = { class: "editor-main" }
const _hoisted_2 = { class: "menubar-area" }
const _hoisted_3 = { class: "menubar-items" }
const _hoisted_4 = { class: "menubar-user" }
const _hoisted_5 = { class: "menubar-user" }
const _hoisted_6 = { class: "editor-area" }
const _hoisted_7 = {
  class: "middle-side",
  ref: "middleRef"
}
const _hoisted_8 = {
  key: 0,
  class: "loader"
}
const _hoisted_9 = {
  key: 1,
  class: "downloader"
}
const _hoisted_10 = {
  key: 3,
  class: "untrackable-overlay"
}
const _hoisted_11 = {
  key: 4,
  style: {"color":"#aaa","margin-top":"8px"}
}
const _hoisted_12 = {
  key: 5,
  class: "pending-counter"
}
const _hoisted_13 = {
  class: "review-actions",
  ref: "actionsRef"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "modal-actions" }
const _hoisted_20 = { class: "right-side-bar" }
const _hoisted_21 = { class: "labels-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageCanvas = _resolveComponent("ImageCanvas")!
  const _component_Labels = _resolveComponent("Labels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "menubar-logo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
      }, _cache[11] || (_cache[11] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1),
        _createElementVNode("span", null, "ision", -1)
      ])),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            title: "Administrator Dashboard",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navToAdmin && _ctx.navToAdmin(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _imports_2,
            alt: "",
            title: "Logout",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navToLogout && _ctx.navToLogout(...args)))
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Load ng"))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9))
          : _createCommentVNode("", true),
        (_ctx.currentImage)
          ? (_openBlock(), _createBlock(_component_ImageCanvas, {
              key: 2,
              image: _ctx.currentImage,
              highLightedLine: _ctx.highlightedLine,
              readOnly: true
            }, null, 8, ["image", "highLightedLine"]))
          : _createCommentVNode("", true),
        (_ctx.currentImage?.is_non_trackable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, "UNTRACKABLE"))
          : _createCommentVNode("", true),
        (!_ctx.currentImage && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, " No Images to Review "))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[12] || (_cache[12] = _createTextVNode(" To Validate: ")),
              _createElementVNode("strong", null, _toDisplayString(_ctx.pendingCount), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "icon-btn",
            disabled: !_ctx.canGoBack || _ctx.loading || _ctx.busy,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            title: "Back"
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("img", {
              src: _imports_3,
              alt: "Back"
            }, null, -1)
          ]), 8, _hoisted_14),
          (_ctx.currentImage && !_ctx.currentImage.is_validated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "icon-btn",
                disabled: !_ctx.currentImage || _ctx.loading || _ctx.busy,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
                title: "Validate"
              }, _cache[14] || (_cache[14] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  alt: "Validate"
                }, null, -1)
              ]), 8, _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.currentImage && !_ctx.currentImage.is_validated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "icon-btn",
                disabled: !_ctx.currentImage,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openInvalidate && _ctx.openInvalidate(...args))),
                title: "Invalidate"
              }, _cache[15] || (_cache[15] = [
                _createElementVNode("img", {
                  src: _imports_5,
                  alt: "Invalidate"
                }, null, -1)
              ]), 8, _hoisted_16))
            : (_ctx.currentImage && _ctx.currentImage.is_validated)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "icon-btn",
                  disabled: !_ctx.currentImage || _ctx.loading || _ctx.busy,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.unvalidate && _ctx.unvalidate(...args))),
                  title: "Invalidate"
                }, _cache[16] || (_cache[16] = [
                  _createElementVNode("img", {
                    src: _imports_5,
                    alt: "Invalidate"
                  }, null, -1)
                ]), 8, _hoisted_17))
              : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "icon-btn",
            disabled: _ctx.loading || _ctx.busy,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextImage && _ctx.nextImage(...args))),
            title: "Next"
          }, _cache[17] || (_cache[17] = [
            _createElementVNode("img", {
              src: _imports_6,
              alt: "Next"
            }, null, -1)
          ]), 8, _hoisted_18)
        ], 512),
        (_ctx.invalidateOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 6,
              ref: "modalRef",
              class: "invalidate-popover",
              style: _normalizeStyle(_ctx.modalStyle),
              role: "dialog",
              "aria-modal": "true"
            }, [
              _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Notes:", -1)),
              _withDirectives(_createElementVNode("textarea", {
                ref: "notesRef",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.invalidateNotes) = $event)),
                rows: "4",
                placeholder: "Add optional notes here..."
              }, null, 512), [
                [_vModelText, _ctx.invalidateNotes]
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.confirmInvalidate && _ctx.confirmInvalidate(...args)))
                }, "Ok"),
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancelInvalidate && _ctx.cancelInvalidate(...args)))
                }, "Cancel")
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "popover-arrow" }, null, -1))
            ], 4))
          : _createCommentVNode("", true)
      ], 512),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          (_ctx.currentImage)
            ? (_openBlock(), _createBlock(_component_Labels, {
                key: 0,
                image: _ctx.currentImage,
                readOnly: true,
                mode: "review",
                wrongIds: Array.from(_ctx.wrongIds),
                onOnLabelFocus: _ctx.onLabelFocus,
                onMarkWrong: _ctx.onMarkWrong
              }, null, 8, ["image", "wrongIds", "onOnLabelFocus", "onMarkWrong"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}